export default __webpack_public_path__ + "static/media/right-arrows.edd14a3d.svg";